var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateNewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,20C3,20.552284,3.44771528,21,4.0000002,21L12,21C16.970563,21,21,16.970563,21,12C21,7.0294371,16.970563,3,12,3C7.0294371,3,3,7.0294371,3,12L3,20ZM4,20L12,20Q15.313711,20,17.656855999999998,17.656855999999998Q20,15.313711,20,12Q20,8.6862907,17.656855999999998,6.3431461Q15.313709,4.0000004,12,4.0000007Q8.6862922,4,6.3431461,6.3431458Q4.0000004,8.6862917,4.0000007,12L4,20Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11.5,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,20.5,-4.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "#FFFFFF",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNewIcon);
export default __webpack_public_path__ + "static/media/create-new-icon.0c534c0bb64e38404e68e97bdd7f1070.svg";
export { ForwardRef as ReactComponent };